module.exports = __webpack_public_path__ + "media/images/icons/flags/KR-b3c87083afcc6cad26ef25cc85adb0a3.svg";